import { render } from "./overlay.vue?vue&type=template&id=3f9e524f"
import script from "./overlay.vue?vue&type=script&lang=js"
export * from "./overlay.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/bootstrap/overlay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f9e524f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f9e524f', __exports__)) {
    api.reload('3f9e524f', __exports__)
  }
  
  module.hot.accept("./overlay.vue?vue&type=template&id=3f9e524f", () => {
    api.rerender('3f9e524f', render)
  })

}


export default __exports__